import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useNavigate } from 'react-router-dom';
import { coachPaths } from '../../routes/coach';

const WorkshopSlider = ({ getAllCoachWorkshop }) => {
    const navigate = useNavigate();

    const formatToCET = (utcDateString) => {
        const date = new Date(utcDateString);
        const formatter = new Intl.DateTimeFormat("en-GB", {
            weekday: "long",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
            timeZone: "Europe/Paris",
        });
        const formattedDate = formatter.format(date);
        const cleaned = formattedDate
            .replace(",", "")
            .replace(",", "")
            .replace(/(\d{1,2})$/, "$1.")
            .trim();
        return `${cleaned} CET`;
    };

    return (
        <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
            }}
            className="ct_coach_created_slider"
        >
            {getAllCoachWorkshop?.length != 0 &&
                getAllCoachWorkshop?.map((item) => (
                    <SwiperSlide>
                        <div className="item">
                            <figure className="mb-0 ct_coach_created_card">
                                <div
                                    class="ct_coach_created_img ct_img_330 ct_cursor_pointer ct_ratio_unset123"
                                    onClick={() =>
                                        navigate(coachPaths?.CoachWork_shopDetail, {
                                            state: { data: item },
                                        })
                                    }
                                >
                                    <img
                                        src={item?.image1 ?? "assets/img/nellie_workshop_1.png"}
                                        alt=""
                                    />
                                </div>

                                <figcaption className="mt-3">
                                    <div className="d-flex align-items-center gap-2 justify-content-between mb-2"
                                        onClick={() =>
                                            navigate(coachPaths?.CoachWork_shopDetail, {
                                                state: { data: item },
                                            })
                                        }
                                    >
                                        <p className="mb-0 ct_fs_18 ct_darkblue_text">
                                            {item?.section_1?.title || ""}
                                        </p>
                                        <p className="mb-0 ct_fs_12 ct_grey_text">
                                            {formatToCET(item?.schedule_date)}
                                        </p>
                                    </div>

                                    <p className="mt-1 mb-2 ct_darkblue_text"
                                        onClick={() =>
                                            navigate(coachPaths?.CoachWork_shopDetail, {
                                                state: { data: item },
                                            })
                                        }
                                    >
                                        By {item?.created_user_name ?? ""}{" "}
                                        {item?.create_role &&
                                            `/ ${item?.create_role} Coach`}
                                    </p>
                                    <p className="ct_fs_14 ct_darkblue_text mt-1"
                                        onClick={() =>
                                            navigate(coachPaths?.CoachWork_shopDetail, {
                                                state: { data: item },
                                            })
                                        }
                                    >
                                        {item?.section_4?.cards?.length != 0 && item?.section_4?.cards[1]?.title || ""}. {item?.hours || ""}. Q&A included
                                    </p>

                                    {/* <div className="mt-3">
                                        <a className="ct_hover_link_orange ct_darkblue_text ct_fs_14">
                                            Register Now{" "}
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </a>
                                    </div> */}
                                </figcaption>
                            </figure>
                        </div>
                    </SwiperSlide>
                ))}
        </Swiper>
    )
};

export default WorkshopSlider;